<template>
    <p class="text-red-500">
        <slot></slot>
    </p>
</template>
<script setup></script>
